import { FlareXMLDeclaration } from '@common/flare/constants/flare-xml-declaration.constant';
import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { defaultToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { NodeIdAttrName, NodeIdMissingValue, NodeIdRootValue } from '@common/prosemirror/model/node-id';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { OperationAttrName } from '@common/prosemirror/operations/operations.constant';
import { getSchemaAttrs } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

/** Variable XML node names. */
export enum VariableXmlNodeName {
  Set = 'CatapultVariableSet',
  Tag = 'Variable',
}

/** Variable tag XML node attribute names. */
export enum VariableTagXmlAttributeName {
  Name = 'Name',
  Comment = 'Comment',
  EvaluatedDefinition = 'EvaluatedDefinition',
  Type = 'Type',
  LastUpdated = 'LastUpdated',
}

export class VariableSetSchemaPlugin extends SchemaPlugin {
  nodes: Dictionary<NodeSpec> = {
    doc: {
      content: VariableXmlNodeName.Set,
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        let xml = FlareXMLDeclaration;

        for (let i = 0; i < node.childCount; i += 1) {
          const child = node.child(i);
          xml += (child.type.spec.toFlareXML ?? defaultToFlareXML)(child, options)
        }

        return xml;
      }
    },

    [VariableXmlNodeName.Set]: {
      content: 'block*',
      attrs: {
        [NodeIdAttrName]: { default: NodeIdRootValue, skipExport: true },
        [OperationAttrName]: { default: undefined, skipExport: true }
      },
      parseDOM: [{
        tag: VariableXmlNodeName.Set,
      }],
    },

    [VariableXmlNodeName.Tag]: {
      group: 'block allow_text_comment', // 'allow_text_comment' - allow comments inside value of the variable tag
      content: 'inline*',
      attrs: {
        [NodeIdAttrName]: { default: NodeIdMissingValue, skipExport: true },
        [VariableTagXmlAttributeName.Name]: { default: undefined },
        [VariableTagXmlAttributeName.Comment]: { default: undefined },
        [VariableTagXmlAttributeName.EvaluatedDefinition]: { default: undefined },
        [VariableTagXmlAttributeName.Type]: { default: undefined },
        [VariableTagXmlAttributeName.LastUpdated]: { default: undefined },
      },
      parseDOM: [{
        tag: VariableXmlNodeName.Tag,
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, [
            VariableTagXmlAttributeName.Name,
            VariableTagXmlAttributeName.Comment,
            VariableTagXmlAttributeName.EvaluatedDefinition,
            VariableTagXmlAttributeName.Type,
            VariableTagXmlAttributeName.LastUpdated
          ]);
        }
      }],
    },
  };
}
